<template>
  <div :key="key" class="dashboard-chart">
    <h4>Compras / Ventas</h4>
    <vue-svg-gauge
      :start-angle="-110"
      :end-angle="110"
      :value="indicadorActual"
      :separator-step= 0
      :min="indicadorMin"
      :max="indicadorMax"
      :gauge-color="indicadorColor"
      :scale-interval="1"/>
      <div class="dashboard-chart-text">
        <p>Pje Objetivo: {{ indicadorObjetivo | numero(2, true) }} %</p>
        <p>Pje Actual: {{ indicadorActual | numero(2, true) }} %</p>
        <p class="description">Ventas: {{ indicadorMontoVentas | moneda }}</p>
        <p class="description">Compras: {{ indicadorMontoCompras | moneda }}</p>
        <p class="description">{{ indicadorDescripcion }}</p>
        <!-- <p v-if="verDatosComprasGastos" 
          class="link" 
          @click.stop="exportarCompras"><i class="fa fa-file-excel-o"></i>Exportar Compras</p> -->
      </div>
  </div>
</template>

<script>
import { VueSvgGauge } from 'vue-svg-gauge';

export default {
  components: {
    VueSvgGauge,
  },
  props: {
    indicadorGastos: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      rojo: '#E46651',
      verde: '#41B883',
      amarillo: '#FAFA05',
      rosa: '#FF0187',

      key: 0,
      indicadorObjetivo: 0,
      indicadorActual: 0,
      indicadorColor: [{ offset: 0, color: '#41B883'}, { offset: 100, color: '#41B883' }],
      // indicadorColor: [{ offset: 0, color: '#41B883'}, { offset: 100, color: '#E46651' }],
      indicadorMin: 0,
      indicadorMax: 100,
      
      indicadorMontoCompras: 0,
      indicadorMontoVentas: 0,
      indicadorDescripcion: '',

      verDatosComprasGastos: false
    }
  },
  created() {
    let userRolId = parseInt(this.$store.getters['user/rolId']);

    switch (userRolId) {
        case 1: /* Superadministrador */ 
        case 2: /* Direccion */
        case 4: /* Produccion */ 
        case 6: /* Director Administrativo */
        case 7: /* Asistente de administracion */
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 20: /* Gerente Comercial */
        case 21: /* Responsable de Finanzas y Proveedores */ 
        case 22: /* Responsable de Facturacion e Impuestos */
        case 23: /* Asistente de Calidad */
          this.verDatosComprasGastos = true;
          break;

        case 3: /* Cuentas */ 
        case 5: /* Diseño */
        case 10: /* Asistente de logistica */
        case 11: /* RRHH */
        case 12: /* Asistente de promociones */
        case 13: /* Asistente de cuentas */
        case 14: /* Asistente de produccion */
        case 15: /* Coordinador/a de promociones */
        case 16: /* Ejecutivo comercial */
        case 17: /* Asistente comercial */
        case 19: /* Coordinador/a comercial */
        case 24: /* Coordinador de Diseño */
          break;
    }
  },
  methods: {
    getIndicador() {
      this.$store.dispatch('resultadosIndicadores/getIndicadorComprasVentas')
        .then(() => this.getDatos());

      // if (!(/true/i).test(this.$store.getters['resultadosIndicadores/indicadorComprasVentasInicializado'])) {
      //   this.$store.dispatch('resultadosIndicadores/getIndicadorComprasVentas')
      //     .then(() => this.getDatos());
      // } else {
      //   this.getDatos();
      // }
    },
    cancelar() {
      this.$store.dispatch('resultadosIndicadores/cancelarIndicadorComprasVentas');
    },
    getDatos() {
      let indicador = this.$store.getters['resultadosIndicadores/indicadorComprasVentas']

      this.indicadorObjetivo = parseFloat(indicador.pjeObjetivo);
      this.indicadorActual = indicador.pjeActual;
      this.indicadorMax = indicador.pjeActual > 100 ? indicador.pjeActual : 100;
      this.indicadorDescripcion = indicador.indicadorPeriodo? indicador.indicadorPeriodo.trim() : '';
      this.indicadorMontoCompras = parseFloat(indicador.montoNetoCompras);
      this.indicadorMontoVentas = parseFloat(indicador.montoNetoVentas);

      if (parseFloat(indicador.pjeObjetivo) == 0) {
        this.indicadorColor = [{ offset: 0, color: this.verde }, { offset: 100, color: this.verde } ];
      } else {
        if (parseFloat(indicador.pjeActual) >= parseFloat(indicador.pjeObjetivo)) {
          this.indicadorColor = [{ offset: 0, color: this.rojo }, { offset: 100, color: this.rojo } ];
        } else if (parseFloat(indicador.pjeActual) >= (parseFloat(indicador.pjeObjetivo) / parseFloat(2)))   {
          this.indicadorColor = [{ offset: 0, color: this.amarillo }, { offset: 100, color: this.amarillo } ];
        }
      }
    },
    exportarCompras() {
      this.showSpinner();
      this.$store.dispatch('resultadosIndicadores/getIndicadorGastosDetalleCompras')
        .then(() => {
          let exportXls = Boolean(false); 
          let compras = this.$store.getters['resultadosIndicadores/indicadorGastosComprobantes'];

          if (compras) {
            if (compras.length != 0) {
              exportXls = Boolean(true);
            }
          }
          if (exportXls) {
            let title= 'Detalle de Compras';
            let fileName = 'compras';
            let format = [
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Fecha', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Moneda', nombre: 'moneda', formato: '' },
              { titulo: 'Total Comprobante', nombre: 'totalComprobante', formato: '' },
              { titulo: 'Neto Comprobante', nombre: 'montoNetoComprobante', formato: '' },
              // { titulo: 'Neto Gastos Producción', nombre: 'montoNetoGastosProduccion', formato: '' },
              { titulo: 'Neto Ordenes Proveedores', nombre: 'montoNetoOrdenesProveedores', formato: '' },
              { titulo: 'Neto Remitos', nombre: 'montoNetoRemitos', formato: '' },
              { titulo: 'Amortización - Años', nombre: 'amortizacionAnios', formato: '' }
            ];

            this.exportXLS(title, fileName, compras, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  }
}
</script>

<style>
</style>


